import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectUser } from '@/store/slices/user/selectors'
import { recordUserVisit } from '@/utils/userActivity'

/** Records the signed-in user's visit once per page load (see `utils/userActivity`). */
export default function useUserActivityTracking(): void {
  const user = useSelector(selectUser)
  const id = user?.userId ?? user?.id
  const userId = id == null ? null : String(id)

  useEffect(() => {
    if (userId) recordUserVisit(userId)
  }, [userId])
}
